import React from 'react';

import { c } from 'ttag';

/**
 * Les deux phrases posées sous l'animation des écrans publics (charte V3).
 *
 * **LE MASQUE EST SUR LE MOT ET NON SUR LA LIGNE, et c'est ce qui change par rapport à
 * la maquette.** Elle code ses deux lignes en dur (`<span class="lv-lm">` autour de
 * chacune) parce qu'un fichier statique connaît sa coupure. Une phrase traduite n'a pas
 * de nombre de lignes : « Piloter vos marchés en autonomie » et sa traduction anglaise
 * ne se coupent pas au même endroit, et un masque de ligne posé au mauvais mot fait
 * monter du texte devant celui de la ligne du dessus. Le masque par mot rend le même
 * geste, chaque mot sortant de sous son propre bord, et la coupure reste au navigateur.
 *
 * Corollaire : le découpage se fait au rendu, sur la chaîne traduite. Les mots ne sont
 * pas des msgid, sinon le catalogue porterait « vos » et « en » sans contexte, ce qui
 * n'est pas traduisible.
 *
 * Le texte n'est pas décoratif et ne porte donc pas `aria-hidden`, contrairement à
 * l'animation qu'il accompagne : c'est la seule phrase de l'écran qui dise à quoi sert
 * le produit.
 */
const LoginClaim = () => {
    const claim = c('Login claim').t`Steering your contracts on your own`;

    return (
        <div className="login-claim">
            <p className="login-claim__lead">
                {c('Login claim')
                    .t`Follow the activity as it happens, without waiting for the next steering committee.`}
            </p>
            <p className="login-claim__title">
                {claim.split(' ').map((mot, index, mots) => (
                    // L'index suffit comme clé : la liste ne se réordonne jamais, elle
                    // est recalculée entière au changement de langue.
                    <React.Fragment key={index}>
                        <span className="login-claim__mask">
                            <i style={{ animationDelay: `${0.4 + index * 0.08}s` }}>{mot}</i>
                        </span>
                        {index < mots.length - 1 && ' '}
                    </React.Fragment>
                ))}
            </p>
        </div>
    );
};

export default LoginClaim;
